
import React from 'react';

const BrandTiles: React.FC = () => {
  const brands = [
    { name: "GEMINI", icon: "/assets/brands/gemini-logo.svg" },
    { name: "CLAUDE", icon: "/assets/brands/claude-logo.svg" },
    { name: "CHATGPT", icon: "/assets/brands/chatgpt-logo.svg" }
  ];

  return (
    <div className="flex items-center justify-center gap-6 md:gap-12 mb-20 animate-in fade-in slide-in-from-bottom-4 duration-1000">
      {brands.map((brand) => (
        <div key={brand.name} className="flex flex-col items-center gap-3 group cursor-pointer">
          <div className="w-16 h-16 md:w-24 md:h-24 rounded-[1.5rem] md:rounded-[2rem] bg-white/5 border border-white/10 flex items-center justify-center group-hover:scale-110 transition-all shadow-xl backdrop-blur-md">
            <img src={brand.icon} className="w-8 h-8 md:w-14 md:h-14" alt={brand.name} />
          </div>
          <span className="text-[8px] md:text-[10px] font-black uppercase tracking-[0.2em] md:tracking-[0.3em] text-slate-500 group-hover:text-white transition-colors">
            BYOK {brand.name}
          </span>
        </div>
      ))}
    </div>
  );
};

export default BrandTiles;
